
$(document).ready(function() {


  // ================================================================
  // tab content in product page 
  $(".tab_content").hide();
  $(".tab_content:first").show();

  /* if in tab mode */
  $("ul.tabs li").click(function() {
    // console.log("click");
    $(".tab_content").hide();
    var activeTab = $(this).attr("rel");
    $("#" + activeTab).fadeIn();

    $("ul.tabs li").removeClass("active");
    $(this).addClass("active");

    $(".tab_drawer_heading").removeClass("d_active");
    $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");

  });
  /* if in drawer mode */
  $(".tab_drawer_heading").click(function() {

    $(".tab_content").hide();
    var d_activeTab = $(this).attr("rel");
    $("#" + d_activeTab).fadeIn();

    $(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");

    $("ul.tabs li").removeClass("active");
    $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
  });
});

function setCookie(cname,cvalue,exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

let countrypop1 = parseInt(getCookie("countrypop1"));
if(isNaN(countrypop1)){
 $.ajax({
  url:"//get.geojs.io/v1/ip/country.json",
  type:"GET",
  dataType:"json",
  success:function(s){
    if(s.country == "IN"){
      Swal.fire({
        title: 'Visiting from '+s.name+'?',
        text: "Shop from your local store for the optimal experience and tailored shipping solutions",
        showCancelButton: true,
        confirmButtonColor: '#00624f',
        cancelButtonColor: '#F06025',
        confirmButtonText: 'YES',
        cancelButtonText: 'NO'
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "https://ecosoul-home-india.myshopify.com";
        } else if(result.isDismissed){
          setCookie("countrypop1", 1, 7);
        }
      });
    }
  }
 }) 
}



/*==== impact tab slider ====*/
$(function () {
    $.FindContainer = function () {
        $('.tab-content>div').each(function findcontent() {
            var newindex = $('.activetab').index();
            var newheight = $('.activetab').height();
            $('.tab-content').animate({
                'height': newheight+20
            }, 100);
            var otherindex = $(this).index();
            var substractindex = otherindex - newindex;
            var currentwidth = $('.multipletab').width();
            var newpositions = substractindex * currentwidth;
            $(this).animate({
                'left': newpositions
            });
        });
    };
    $.FindId = function () {
        $('.tab-content>div').each(function () {
            if ($(this).attr('id') == $('.active').attr('id')) {
                $('.tab-content>div').removeClass('activetab');
                $(this).addClass('activetab');
            }
        });
    };
    $('.tab-buttons>span').first().addClass('active');
    $('.tab-content>div').each(function () {
        var activeid = $('.active').attr('id');
        if ($(this).attr('id') == activeid) {
            $(this).addClass('activetab');
        }
        var currentheight = $('.activetab').height();
        var currentwidth = $('.multipletab').width();
        var currentindex = $(this).index();
        var currentposition = currentindex * currentwidth;
        $(this).css({
            'left': currentposition,
                'width': currentwidth,
        });
        $(this).attr('data-position', currentposition);
        $('.tab-content').css('height', currentheight+20);
    });
    $('.tab-buttons>span').click(function () {
        $('.tab-buttons>span').removeClass('active');
        $(this).addClass('active');
        var currentid = $('.active').attr('id');
        $.FindId();
        $.FindContainer();
      // $('.impact-tab .impact-tab-pattern-step').slick('refresh');
    });
});
/*==== impact tab slider ====*/

/*==== chart js ====*/
var piesiteFired = 0;
$(document).ready(function() {
    var $win = $(window),
        $win_height = $(window).height(),
        // - A multiple of viewport height - The higher this number the sooner triggered.
        windowPercentage = $(window).height() * 0.9;
    $win.on("scroll", scrollReveal);
    function scrollReveal() {
        var scrolled = $win.scrollTop();
        
        ///////////////////////////////////////
        // Bar Charts scroll activate, looking for .trigger class to fire.
        $(".trigger").each(function() {
            var $this = $(this),
                offsetTop = $this.offset().top;
            if (
                scrolled + windowPercentage > offsetTop ||
                $win_height > offsetTop
            ) {
                $(this).each(function(key, bar) {
                    var percentage = $(this).data("percentage");
                    $(this).css("height", percentage + "%"); 
                    
                    ///////////////////////////////////////
                    //        Animated numbers
                    $(this).prop("Counter", 0).animate(
                        {
                            Counter: $(this).data("percentage")
                        },
                        {
                            duration: 2000,
                            easing: "swing",
                            step: function(now) {
                                $(this).text(Math.ceil(now));
                            }
                        }
                    );
                    //        Animated numbers
                    ///////////////////////////////////////
                });

            } else {
                ///////////////////////////////////////
                // To keep them triggered, lose this block.
                $(this).each(function(key, bar) {
                    $(this).css("height", 0);
                });
            }    
            
        });

        ///////////////////////////////////////
        // Horizontal Chart
        $(".chartBarsHorizontal .bar").each(function() {
            var $this = $(this),
                offsetTop = $this.offset().top;
            if (
                scrolled + windowPercentage > offsetTop ||
                $win_height > offsetTop
            ) { 
                $(this).each(function(key, bar) {
                    var percentage = $(this).data("percentage");
                    $(this).css("width", percentage + "%");
                    ///////////////////////////////////////
                    //        Animated numbers
                    $(this).prop("Counter", 0).animate(
                        {
                            Counter: $(this).data("percentage")
                        },
                        {
                            duration: 2000,
                            easing: "swing",
                            step: function(now) {
                                $(this).text(Math.ceil(now));
                            }
                        }
                    );
                    //        Animated numbers
                    ///////////////////////////////////////
                });
    
            } else {
                ///////////////////////////////////////
                // To keep them triggered, lose this block.
                $(this).each(function(key, bar) {
                    $(this).css("width", 0);
                });
            }    
            
        });
        
        ///////////////////////////////////////
        // Radial Graphs - scroll activate
        $(".piesite").each(function() {
            var $this = $(this),
                offsetTop = $this.offset().top;
            if (
                scrolled + windowPercentage > offsetTop ||
                $win_height > offsetTop
            ) {
                if (piesiteFired == 0) {
                    timerSeconds = 3;
                    timerFinish = new Date().getTime() + timerSeconds * 1000;
                    $(".piesite").each(function(a) {
                        pie = $("#pie_" + a).data("pie");
                        timer = setInterval(
                            "stoppie(" + a + ", " + pie + ")",
                            0
                        );
                    });
                    piesiteFired = 1;
                }
            } else {
                // To keep them triggered, lose this block.
                $(".piesite").each(function() {
                    piesiteFired = 0;
                });
            }
        });
    }
    scrollReveal();
});



///////////////////////////////////////
//        The Radial Graphs
///////////////////////////////////////

// The following code is originally from the excellent pen:
// https://codepen.io/StephenScaff/pen/VYaQGB by Stephen Scaff

var timer;
var timerFinish;
var timerSeconds;

function drawTimer(c, a) {
    $("#pie_" + c).html(
        '<div class="percent"></div><div id="slice"' +
            (a > 50 ? ' class="gt50"' : "") +
            '><div class="pie"></div>' +
            (a > 50 ? '<div class="pie fill"></div>' : "") +
            "</div>"
    );
    var b = 360 / 100 * a;
    $("#pie_" + c + " #slice .pie").css({
        "-moz-transform": "rotate(" + b + "deg)",
        "-webkit-transform": "rotate(" + b + "deg)",
        "-o-transform": "rotate(" + b + "deg)",
        transform: "rotate(" + b + "deg)"
    });
    a = Math.floor(a * 100) / 100;
    arr = a.toString().split(".");
    intPart = arr[0];
    $("#pie_" + c + " .percent").html(
        '<span class="int">' +
            intPart +
            "</span>" +
            '<span class="symbol">%</span>'
    );
}
function stoppie(d, b) {
    var c = (timerFinish - new Date().getTime()) / 1000;
    var a = 100 - c / timerSeconds * 100;
    a = Math.floor(a * 100) / 100;
    if (a <= b) {
        drawTimer(d, a);
    } else {
        b = $("#pie_" + d).data("pie");
        arr = b.toString().split(".");
        $("#pie_" + d + " .percent .int").html(arr[0]);
    }
}


if ($(window).width() < 1301 ) {
  $(".impact-tab .impact-tab-pattern-step").slick({  
    responsive: [
      {
        breakpoint: 1300,
        settings: {
            slidesToShow: 4,
            slidesToScroll:1,
            infinite: false,
            arrows:false, 
        }
      },      
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll:1,
          infinite: false,
          arrows:false,           
        }       
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll:1,
          infinite: false,
          arrows:true,           
        }       
      },      
       {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll:1,
          infinite: false,
          arrows:true,           
          }
      }
    ]
  });  
  } else{      
       $(".impact-tab .impact-tab-pattern-step").slick("unslick");   
  }

if ($(window).width() < 1301 ) {
  $(".dd-page-impact .index-logo-main .logos_outer").slick({  
    responsive: [    
      {
        breakpoint: 1300,
        settings: {
        slidesToShow: 4,
        slidesToScroll:1,
        infinite: false,
        arrows:false,           
        }       
      },   
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll:1,
          infinite: false,
          arrows:false,           
        }       
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll:1,
          infinite: false,
          arrows:false,           
        }       
      },      
       {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll:1,
          infinite: false,
          arrows:false,           
          }
      }
    ]
  });  
  } else {
     $(".dd-page-impact .index-logo-main .logos_outer").slick("unslick");
  }

  $('.dd-page-our-story .dd-logo-bar').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: 'linear',
    arrows:false,
    responsive: [    
      {
        breakpoint: 1300,
        settings: {
        slidesToShow: 4.5
        }       
      },   
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3         
        }       
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,        
        }       
      }
    ]
  });

$(document).ready(function(){
  atc_custom();

var isALARendered;
function ALAcheck() {
  isALARendered = setInterval(function () {
    customALA()
  }, 200);
}
ALAcheck();

  function customALA() {
var selector = $('.product-recommendations');
  if(selector.length > 0) {
    clearInterval(isALARendered);        
   atc_custom();
  }  
}



});




 /* META – ADD TO CART */
document.addEventListener('submit', function (e) {

  var form = e.target;

  if (form && form.action && form.action.indexOf('/cart/add') !== -1) {

    var formData = new FormData(form);
    var variantId = formData.get('id');
    var quantity = formData.get('quantity') || 1;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        if (typeof fbq === 'function') {
          fbq('track', 'AddToCart', {
            content_ids: [variantId],
            content_type: 'product',
            value: cart.items_subtotal_price / 100,
            currency: cart.currency,
            quantity: quantity
          });
        }
      });
  }
});

